/**
 * Generates the output of image metadata depending on what meta is available.
 * @param {string} name Owner/source name
 * @param {string} url Owner/source url
 * @returns {string}
 */
const generateMetaDisplay = (name, url) => {
	if (name && url) {
		return `<a href="${url}" target="_blank">${name}</a>`;
	}
	if (name && !url) {
		return name;
	}
	return '';
};

window.addEventListener('DOMContentLoaded', () => {
	// Find image credits block. Stop script if no block found.
	const imageCreditsBlock = document.querySelector('.wp-block-mavis-image-credits');
	if (!imageCreditsBlock) {
		return;
	}

	// Find all captions on page. Stop script if no credits found.
	const allCaptions = [
		...document.querySelectorAll('figcaption.wp-element-caption.screen-reader-text'),
	];
	if (allCaptions.length === 0) {
		return;
	}

	const parsedCaptions = allCaptions.map((caption, index) => {
		const { ownerName, ownerUrl, sourceName, sourceUrl } = caption.dataset;
		const captionText = caption.textContent || '';
		const ownerDisplay = generateMetaDisplay(ownerName, ownerUrl);
		const sourceDisplay = generateMetaDisplay(sourceName, sourceUrl);
		const captionDashDisplay = captionText && (ownerDisplay || sourceDisplay) ? ' - ' : '';
		const onTextDisplay = ownerDisplay && sourceDisplay ? ' on ' : '';
		const commaDisplay = index !== allCaptions.length - 1 ? ', ' : '';

		return `<li>${captionText}${captionDashDisplay}${ownerDisplay}${onTextDisplay}${sourceDisplay}${commaDisplay}</li>`;
	});

	const creditsString = parsedCaptions.join('');

	// Append to existing innerHTML of image credits block and un-hide it.
	imageCreditsBlock.innerHTML = `<ul title="Image Credits"><li aria-hidden="true">Credits: </li>${creditsString}</ul>`;
	imageCreditsBlock.classList.remove('is-hidden');
});
